export class ErrorCodeGeneralToken {
  static IErrorCodeGeneralRepository = Symbol("IErrorCodeGeneralRepository");
  static ErrorCodeGeneralUseCase = Symbol("ErrorCodeGeneralUseCase");
  static ErrorCodeGeneralViewModel = Symbol("ErrorCodeGeneralViewModel");
}
